export default __webpack_public_path__ + "static/media/about-img-01@medium.f4609ac9.jpg";